import React from 'react';
import '../../styles/PresentationHomogene.css';
import ImgGareTrooEt21 from '../../images/Detage1.jpg';
import ImgGareTrooEt22 from '../../images/Detage2.jpg';

const Detage = () => {
    return (
        <div className='presentation-section'>
            <div className='presentation-card'>
                <div className='section-header'>
                    <h1 className='section-title'>Deuxième Étage</h1>
                </div>
                
                <div className='section-content'>
                    <div className='section-image'>
                        <img src={ImgGareTrooEt21} alt="Deuxième étage - Trains miniatures" />
                    </div>
                    <div className='section-text'>
                        <p className='section-description'>
                            Au deuxième et dernier étage une salle de trains miniatures
                            qui ravit les petits et les grands.
                        </p>
                    </div>
                    <div className='section-image'>
                        <img src={ImgGareTrooEt22} alt="Exposition de trains miniatures" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Detage;